import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Integration, IntegrationType } from '@pdqdev/pdq-shared/dist/entities';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { TimeUnits } from '@utils/index';
import { ApiService } from '@core/services/api/api.service';
import { IntegrationsService } from '@services/integrations/integrations.service';
import { ToastService } from '@storybook/services/toast/toast.service';

enum WidgetContext {
  TICKET = 'ticket',
  CUSTOMER = 'customer',
}

@Component({
  selector: 'gorgias-settings',
  templateUrl: './gorgias-settings.component.html',
  styleUrls: ['./gorgias-settings.component.scss'],
  standalone: false,
})
export class GorgiasSettingsComponent implements OnInit, OnDestroy {
  @Input() integrationType: IntegrationType;
  @Input() integration: Integration | any;

  ticketWidgetOn: boolean;
  customerWidgetOn: boolean;

  Feature = WidgetContext;
  featureToggle$ = new Subject<{ feature: WidgetContext; value: boolean }>();
  destroy$ = new Subject();
  constructor(
    private apiService: ApiService,
    private integrationService: IntegrationsService,
    private toastService: ToastService,
  ) {}
  ngOnDestroy(): void {
    this.destroy$.next(true);
  }

  ngOnInit(): void {
    this.initFeaturesState();
    this.featureToggle$
      .pipe(takeUntil(this.destroy$), debounceTime(TimeUnits._SECOND_IN_MS * 1), distinctUntilChanged())
      .subscribe(({ feature, value }) => this.toggleWidget(value, feature as WidgetContext));
  }

  initFeaturesState() {
    this.ticketWidgetOn = this.integration?.metadata?.gorgias?.widgets?.find?.(
      (widget) => widget.context === WidgetContext.TICKET && widget.isActive,
    );

    this.customerWidgetOn = this.integration?.metadata?.gorgias?.widgets?.find?.(
      (widget) => widget.context === WidgetContext.CUSTOMER && widget.isActive,
    );
  }

  handleToggle(value: boolean, feature: WidgetContext) {
    this.featureToggle$.next({ feature, value });
  }

  toggleWidget(newIsActive: boolean, context: WidgetContext) {
    this.apiService
      .post('integrations/gorgias/widget', {
        newActive: newIsActive,
        context,
      })
      .subscribe(
        (updatedIntegration) => {
          this.integrationService.updateIntegrationState(updatedIntegration);
        },
        (err) => {
          console.log(err);
          this.toastService.showToast({
            mode: 'danger',
            message: `Failed to toggle ${newIsActive ? 'on' : 'off'} widget`,
          });
        },
      );
  }
}
